// ═══════════════════════════════════════════════════════════
// 跨页面播放器启动 — 保存状态并导航到 player.html
// ═══════════════════════════════════════════════════════════

import { storage } from '../lib/storage.js';

export function savePlayerStateAndNavigate(url, title, episodeIndex) {
    const eps = window.getCurrentEpisodes ? window.getCurrentEpisodes() : [];
    const reversed = false;

    storage.playerState = {
        title: title,
        episodeIndex: episodeIndex,
        episodes: eps,
        reversed: reversed,
    };

    const playerUrl = `player.html?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&index=${episodeIndex}`;
    window.open(playerUrl, '_blank');
}

// 全局暴露
window.savePlayerStateAndNavigate = savePlayerStateAndNavigate;
